export const geoApiOptions = {
          method: 'GET',
          headers: {
                    'X-RapidAPI-Key': '512815bef1mshd1b4bf6064c0d5fp14e49ajsn773869517b81',
                    'X-RapidAPI-Host': 'wft-geo-db.p.rapidapi.com'
          }
};

export const GEO_API_URL = "https://wft-geo-db.p.rapidapi.com/v1/geo"

export const WEATHER_API_URL = "https://api.openweathermap.org/data/2.5"
export const WEATHER_API_KEY = "066d0487295052efa9a76161b2fc4b38"